import React, {Component} from 'react'
import Screen from '../_Screen'
import Button from '../Button'
import styled from 'styled-components'
import {Wrapper, Title, Subtitle} from '../Intro'
import DigitalPreview from './DigitalPreview'

class Confirmation extends Screen
	render: ()->
		<Screen {@props...}>
			<Wrapper>
				<Title>{@props.title}</Title>
				<Subtitle>{@props.subtitle}</Subtitle>

				<Previews>
					<DigitalPreview
						data={@props.formState.values}
						currentScreen={@props.formState.current}
						label
						scale={0.65}
					/>
				</Previews>

				<Actions>
					<Button label='Back' secondary action={@prev.bind(@)} />
					<Button label={@props.cta} action={@next.bind(@)} />
				</Actions>
			</Wrapper>
		</Screen>

	next: ()->
		@props.submit()


Previews = styled.div"""
	display: flex;
	justify-content: center;
	flex-wrap: nowrap;

	@media (max-width:660px) {
		flex-direction: column
	}
"""

Actions = styled.div"""
	margin-top: 40px
"""



export default Confirmation